import { PortVisitSrc } from './PortVisitSrc';

export enum DaySrcType {
	Cruising = 'CRUISING',
	CruisingIntDate = 'CRUISING_INTERNATIONAL_DATE_LINE',
	MultiPort = 'MULTI_PORT',
	Port = 'PORT',
	PortTour = 'PORT_TOUR',
	Tour = 'TOUR',
}

export interface DaySrc {
	number: number,
	type: DaySrcType,
	ports: Array<PortVisitSrc>,
}